module.exports = "/assets/data/abda0c979265f5a856c152645f2368f0-SS5.data.json";